import { Component, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import anime from 'animejs';

import { finalize } from 'rxjs/operators';

import { User } from '@app/_models';
import { UserService, AuthenticationService } from '@app/_services';

@Component({
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.css']
})

export class HomeComponent implements AfterViewInit {
    currentUser: User;
    currentUserInfo = null;
    menuPosition: any;
    isVisible = false;
    isVisibleMobile = false;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {
        this.currentUserInfo = this.authenticationService.currentUserInfo;
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        // if (this.authenticationService.currentUserValue) { 
        //     this.router.navigate(['/files']);
        // }
    }
    
    ngAfterViewInit(): void {
        // Wrap every letter in a span
        /*
        const textWrapper = document.querySelector('.an-1');
        textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");
    
        anime.timeline({loop: true})
            .add({
                targets: '.an-1 .letter',
                scale: [4,1],
                opacity: [0,1],
                translateZ: 0,
                easing: "easeOutExpo",
                duration: 950,
            delay: (el, i) => 70*i
            }).add({
                targets: '.an-1',
                opacity: 0,
                duration: 1000,
                easing: "easeOutExpo",
                delay: 1000
            });

        anime.timeline({loop: true})
            .add({
                targets: '.db-text img',
                opacity: [0,1],
                translateY: 20,
                easing: "easeOutExpo",
                duration: 2000,
                delay: (el, i) => 140*i
            }).add({
                targets: '.db-text',
                opacity: [1],
                delay: 2000
            })
        */
    }

    ngOnInit() {
        window.scrollTo(0, 0);
    }

    public goTop() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    showModal(): void {
        this.isVisible = true;
    }

    showModalMobile(): void {
        this.isVisibleMobile = true;
    }

    handleOk(): void {
        console.log('Button ok clicked!');
        this.isVisible = false;
        this.isVisibleMobile = false;
    }
    
    handleCancel(): void {
        console.log('Button cancel clicked!');
        this.isVisible = false;
        this.isVisibleMobile = false;
    }
    
}